var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCmdIconShortBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "52px",
    height: "52px",
    viewBox: "0 0 52 52",
    enableBackground: "new 0 0 52 52",
    xmlSpace: "preserve",
    fill: "#4159B0",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "inherit",
    d: "M27.41,49.49h-0.02v0.01h-0.32C13.78,49.5,3,38.98,3,26 C3,13.03,13.78,2.5,27.07,2.5h0.02h0.01h0.31v9.21h-0.02H27.1c-8.09,0.01-14.63,6.39-14.63,14.281c0,7.9,6.55,14.279,14.64,14.279 h0.3V49.49z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "inherit",
    d: "M30.96,29.35c-0.32,0.141-0.54,0.23-1,0.23 c-2.45,0-2.64-2.371-2.64-2.371v-4.02l0.06-0.46l0.06-0.01h5.05v3.96C32.49,26.68,32.34,28.76,30.96,29.35z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "inherit",
    d: "M43.89,29.35c-0.32,0.141-0.54,0.23-1.01,0.23 c-2.44,0-2.63-2.371-2.63-2.371v-4.02l0.06-0.46l0.06-0.01h5.05v3.96C45.42,26.68,45.27,28.76,43.89,29.35z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "inherit",
    d: "M37.08,37.43c-0.24,0.07-0.37,0.109-0.67,0.109 c-2.44,0-2.63-2.35-2.63-2.35v-4.029l0.05,0.439l0.22-0.02h4.9v3.968C38.95,35.549,38.77,36.99,37.08,37.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "inherit",
    d: "M37.41,29.35c-0.32,0.141-0.55,0.23-1,0.23 c-2.44,0-2.63-2.371-2.63-2.371v-4.02l0.05-0.46l0.22-0.01h4.9v3.96C38.95,26.68,38.79,28.77,37.41,29.35z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "inherit",
    d: "M37.08,21.5c-0.24,0.06-0.37,0.1-0.67,0.1 c-2.44,0-2.63-2.35-2.63-2.35V15.23l0.05-0.08l0.22-0.03h4.9v3.98C38.95,19.1,38.77,21.049,37.08,21.5z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCmdIconShortBlue);
export default __webpack_public_path__ + "static/media/cmd-icon-short-blue.7cb60a76c96af64164807c3dea151156.svg";
export { ForwardRef as ReactComponent };